const Modal = ({
	setShowModal,
	headerTitle,
	handleSubmit,
	children,
	handleCancelModalButton,
	showModal = true,
	withHeader = true,
	headerBg = 'bg-primary',
	closeButtonText = 'Annuler',
	submitButtonText = 'Confirmer',
	showFooterButtons = true,
	image = null,
}) => {
	// This method closes the modal if the user clicks outside of it
	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget && !showModal) {
			setShowModal(false);
		}
	};

	if (!showModal) {
		return null;
	}

	return (
		<>
			{/* Overlay with blur effect */}
			<div
				className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm z-20"
				onClick={handleOverlayClick}
			></div>

			{/* Modal content */}
			<div className="fixed inset-0 z-20 flex items-center justify-center pointer-events-none">
				<div className="bg-white rounded-lg shadow-md w-full max-w-md mx-4 pointer-events-auto">
					{/* Modal header */}
					{withHeader && (
						<div className={`${headerBg} h-[60px] rounded-t-lg flex items-center`}>
							<h2 className={`text-white font-bold text-xl px-4 py-2`}>{headerTitle}</h2>
						</div>
					)}

					{/* Modal content */}
					<div className="py-12 px-4">
						{image && (
							<div className="mb-4 flex justify-center">
								<img 
									src={image} 
									alt="Category" 
									className="w-[150px] h-[150px] object-cover rounded-lg border border-gray-200"
								/>
							</div>
						)}
						<div className="text-center text-xl">
							{children}
						</div>
					</div>

					{/* Modal footer */}
					{showFooterButtons && (
						<div className="flex justify-center gap-4 p-4 border-t border-gray-5500">
							<button 
								type="button" 
								onClick={handleCancelModalButton} 
								className="text-lg px-6 py-2 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-white transition duration-300"
							>
								{closeButtonText}
							</button>

							<button
								type="button"
								onClick={handleSubmit}
								className="text-lg bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary/80 transition duration-300"
							>
								{submitButtonText}
							</button>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Modal;
